import React from "react";
import { Text as RNText } from "react-native";
import { useTheme } from "./base/ThemeContext";
import { usePaletteColor } from "./hooks/use-palette-color";
const Text = ({ variant = "body1", color = "on-background", style, ...rest }) => {
    const { typography } = useTheme();
    const palette = usePaletteColor(color);
    return <RNText {...rest} style={[typography[variant], { color: palette.main }, style]}/>;
};
export default Text;
